// CalendarDay.jsx
import React from "react";
import CalendarTicket from "./CalendarTicket";

const CalendarDay = ({
  day,
  tickets = [],
  year,
  month,
  isCurrentMonth = true,
  onDayClick,
}) => {
  const handleClick = () => {
    onDayClick && onDayClick({ day, month, year, tickets });
  };

  const isToday = () => {
    const today = new Date();
    return (
      day === today.getDate() &&
      month === today.getMonth() &&
      year === today.getFullYear()
    );
  };

  const displayedTickets = tickets.slice(0, 3);
  const remainingTickets = tickets.length - 3;

  return (
    <div
      onClick={handleClick}
      className={`flex flex-col items-start justify-between p-2 min-h-[120px] border-r border-[#BFC2CE] cursor-pointer
        ${!isCurrentMonth ? "bg-[#F8F9FE]" : "bg-white"}`}
    >
      {day && (
        <div
          className={`mb-1 font-OpenSansRegular text-[16px] not-italic font-normal leading-normal tracking-[-0.24px] text-[#80869E] ${
            !isCurrentMonth ? "text-[#404A6E]" : ""
          } ${isToday() && isCurrentMonth ? "text-[#0065FD] font-extrabold" : ""}`}
        >
          {day}
        </div>
      )}
      <div className="space-y-1">
        <div className="grid grid-cols-2 gap-2">
          {displayedTickets.map((ticket, i) => (
            <CalendarTicket
              key={i}
              status={ticket.status}
              startDateString={ticket.startDate}
              ticketNumber={ticket.number}
            />
          ))}
          {remainingTickets > 0 && (
            <div className="flex shrink-0 rounded-full w-[30px] text-[12px] justify-center items-center bg-[#E6E7EC]">
              +{remainingTickets}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarDay;
